export const checkOverflow = (element: HTMLElement | null) => {
  if (!element) {
    return false;
  }

  const curOverflowStyle = element.style.overflow;

  if (!curOverflowStyle || curOverflowStyle === 'scroll') {
    element.style.overflow = 'hidden';
  }

  const { clientWidth, clientHeight, scrollWidth, scrollHeight } = element;
  const isOverflowing = clientWidth < scrollWidth || clientHeight < scrollHeight;

  element.style.overflow = curOverflowStyle;

  return isOverflowing;
};
